<template>
    <div class="full-width" :style="{ width: componentWidth, height: componentHeight }">
        <cardEditor :fullScreen="fullScreen" />
    </div>
</template>

<script setup>
    import cardEditor from "@/components/shopopee/card/cardEditor"
    import {getCurrentInstance, inject, onMounted, onUnmounted, ref} from "vue";

    const props = defineProps(["fullScreen"])

    let { proxy } = getCurrentInstance();

    const { goMyCardView } = inject('phoneView', { goMyCardView: () => { routeToMyCard() } })

    const componentWidth = ref(null)
    const componentHeight = ref(null)

    function listenIframeEvent(e){
        if (e.data.type == 'closeMemberworkEditor'){
            goMyCardView()
        }
    }

    function routeToMyCard(){
        proxy.$router.push({name: "myCard"})
    }

    onMounted(() => {
        if (false === props.fullScreen){
            componentWidth.value = null
            componentHeight.value = null
        }else{
            componentWidth.value = `${window.innerWidth}px`
            componentHeight.value = `${window.innerHeight}px`
        }

        window.addEventListener("message", listenIframeEvent)
    })

    onUnmounted(() => {
        window.removeEventListener("message", listenIframeEvent)
    })

</script>

<style scoped>
    .full-width {
        width: 100%;
        height: 100%;
    }
</style>